import { ArticleType } from "../constants/resultType"
import { Article } from "../typings/Article"
import { HotArticle } from "../typings/HotArticle"

const hotArticlesToArticles = (hotArticles: HotArticle[]): Article[] =>
  hotArticles.map(({ data }) => ({
    title: data.title,
    type: ArticleType.ARTICLE,
    main_image: data.mainImage && data.mainImage.cdnUrl,
    main_category: data.mainCategory,
    publish_start_at_ts: data.publishTime,
    id: String(data.articleId),
    lead: "",
    url: `${process.env.REACT_APP_HK01_WEB_DOMAIN}/${
      data.mainCategory
    }/${String(data.articleId)}/${data.title.replace(" ", "-")}`,
    main_category_url: `${process.env.REACT_APP_HK01_WEB_DOMAIN}/channel/${data.mainCategory}`,
  }))

const secondToTime = (second?: number): string => {
  if (!second) return "00:00"
  const hour = Math.floor(second / 3600)
  const hourStr = String(hour).padStart(2, "0")
  const minStr = String(Math.floor((second % 3600) / 60)).padStart(2, "0")
  const secStr = String((second % 3600) % 60).padStart(2, "0")

  return hour === 0 ? `${minStr}:${secStr}` : `${hourStr}:${minStr}:${secStr}`
}

const cleanupQuery = (query: string): string => {
  const orgQuery = query ? query.trim() : ""
  // eslint-disable-next-line no-useless-escape
  const regexChecker = /^[.!#()\[\]{}*+\-_一,:;<>?@/^|%&~£¥$§€†‡`"'‘’“”]+$/
  const nonEmptyQuery = orgQuery
    .split(" ")
    // https://discourse.algolia.com/t/special-characters-do-not-affect-results-when-searching/3078
    .find((q) => {
      const isFakeQuery = regexChecker.test(q)
      return !isFakeQuery
    })
  if (nonEmptyQuery) return orgQuery
  return ""
}

export { hotArticlesToArticles, secondToTime, cleanupQuery }
